import React from 'react';
import warningAlert from '../../../assets/icons/alert-yellow-icon.svg';
import Button from '../../../components/Button';
import messages from './messages';
import { useIntl } from 'react-intl';

const getImageByCoyntry = () => {
  const host = window.location.host;
  if (host?.includes('vlucht-vertraagd')) {
    return require('../../../assets/images/passports/netherlands.jpeg');
  } else if (host?.includes('flight-delayed.co.uk')) {
    return require('../../../assets/images/passports/united-kingdom.jpeg');
  } else if (host?.includes('vol-retarde')) {
    return require('../../../assets/images/passports/france.jpeg');
  } else if (host?.includes('flug-verspaetet')) {
    return require('../../../assets/images/passports/germany.jpeg');
  } else if (host?.includes('.be')) {
    return require('../../../assets/images/passports/belgium.jpeg');
  } else if (host?.includes('vuelo-retrasado')) {
    return require('../../../assets/images/passports/spain.jpeg');
  } else if (host?.includes('volo-in-ritardo')) {
    return require('../../../assets/images/passports/italy.jpeg');
  } else if (host?.includes('fly-forsinket')) {
    return require('../../../assets/images/passports/denmark.jpeg');
  } else if (host?.includes('lot-opozniony')) {
    return require('../../../assets/images/passports/poland.jpeg');
  } else if (host?.includes('flight-delayed.com')) {
    return require('../../../assets/images/passports/usa.jpeg');
  }
  return require('../../../assets/images/passports/netherlands.jpeg');
};

const InvalidDocument = (props: any) => {
  const { setShowWarning } = props;
  const { formatMessage } = useIntl();

  return (
    <div
      className="flex"
      style={{
        height: 'auto',
        background: '#fff9e7',
        borderLeft: 'solid',
        borderLeftColor: '#ff8f00',
        borderLeftWidth: '4px',
        marginTop: '3%',
      }}
    >
      <div style={{ marginLeft: '2%', marginTop: '5%' }}>
        <img width={70} src={warningAlert} alt={'info icon'} />
      </div>
      <div style={{ marginLeft: '3%', marginRight: '3%', marginTop: '3%' }}>
        <p style={{ marginTop: 0 }}>
          {formatMessage(messages.invalidDocuments)}
        </p>
        <div style={{ maxWidth: '50%', marginTop: '3%' }}>
          <img
            alt={'passport image'}
            width={'auto'}
            src={getImageByCoyntry()}
          />
        </div>
        <div style={{ maxWidth: '50%', marginTop: '5%', marginBottom: '5%' }}>
          <Button
            theme="secondary"
            type="button"
            width="full"
            size="small"
            // eslint-disable-next-line react/jsx-no-bind
            onClick={() => setShowWarning(false)}
          >
            {formatMessage(messages.closeButton)}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InvalidDocument;
